var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDekLoomine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110.501,
    cy: 33.7394,
    r: 3.73942,
    fill: "#E4966A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.458,
    cy: 42.0494,
    r: 2.07746,
    fill: "#009B81"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.811,
    cy: 65.3169,
    r: 2.90844,
    fill: "#009B81"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.092,
    cy: 53.6829,
    r: 2.90844,
    fill: "#009B81"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.7892,
    cy: 58.2535,
    r: 4.15492,
    fill: "#009B81"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.008,
    cy: 52.852,
    r: 2.90844,
    fill: "#009B81"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.8898 113.122C63.1035 116.629 57.1201 118.091 51.256 117.186C45.3919 116.281 40.1273 113.084 36.6204 108.298C33.1136 103.512 31.6517 97.5284 32.5564 91.6643C33.461 85.8002 36.6582 80.5356 41.4445 77.0287",
    stroke: "#E4966A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.56 55.3118L97.2099 60.7132V47.866H73.1348V61.3695H59.7598V91.0771H97.2099V83.6313L102.56 78.2299V93.7994C102.559 94.5102 102.279 95.1916 101.781 95.694C101.283 96.1963 100.608 96.4785 99.9037 96.4785H57.066C56.7147 96.476 56.3674 96.4037 56.0438 96.2657C55.7201 96.1277 55.4266 95.9267 55.18 95.6741C54.9333 95.4216 54.7383 95.1225 54.6062 94.7939C54.474 94.4653 54.4073 94.1136 54.4097 93.7589V58.6688L70.4678 42.4646H99.8796C101.356 42.4646 102.56 43.6934 102.56 45.1437V55.3118ZM104.641 60.8482L108.424 64.6697L87.6173 85.6757L83.8295 85.6703L83.8349 81.8569L104.641 60.8509V60.8482Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDekLoomine);
export default __webpack_public_path__ + "static/media/dek-loomine.494c0d2607a41c66d9eb017777c2764d.svg";
export { ForwardRef as ReactComponent };